module.exports = __webpack_public_path__ + "img/DSC_0015.115af16a.jpeg";